import React, { useEffect, useRef } from "react";
import ChatMessage from "../../components/chat/ChatMessage";

interface ChatLogProps {
  chatLog: any[];
  readMessage: (message: string, playbackRate: number, key: string) => void;
  pauseCurrentAudio: (key: string) => void;
  resumeCurrentAudio: (key: string) => void;
  adjustPlaybackRate: (rate: number, key: string) => void;
  activeAudio: string | null;
  isPaused: { [key: string]: boolean };
  selectedRates: number;
  isSmallScreen: boolean;
  handleFeedback: (message: any, type: string) => void;
  loadingFeedback: { [key: string]: boolean };
  feedbackGiven: { [key: string]: string };
  showDownOptions: { [key: string]: boolean };
  setShowDownOptions: React.Dispatch<
    React.SetStateAction<{ [key: string]: boolean }>
  >;
  handleSubmitFeedback: (detail: string) => void;
  setShowFeedbackModal: React.Dispatch<React.SetStateAction<boolean>>;
  isLoadingResponse: boolean;
}

const ChatLog: React.FC<ChatLogProps> = (props) => {
  const {
    chatLog,
    readMessage,
    pauseCurrentAudio,
    resumeCurrentAudio,
    adjustPlaybackRate,
    activeAudio,
    isPaused,
    selectedRates,
    isSmallScreen,
    handleFeedback,
    loadingFeedback,
    feedbackGiven,
    showDownOptions,
    setShowDownOptions,
    handleSubmitFeedback,
    setShowFeedbackModal,
    isLoadingResponse,
  } = props;

  const chatContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [chatLog]);

  const lastMessage = chatLog.length > 0 ? chatLog[chatLog.length - 1] : null;
  const isLastMessageFromTrixie =
    lastMessage && lastMessage.sender === "Trixie";

  return (
    <div className="chat-log" id="chatLog" ref={chatContainerRef}>
      {chatLog.map((msg, index) => (
        <ChatMessage
          key={index}
          msg={msg}
          readMessage={readMessage}
          pauseCurrentAudio={pauseCurrentAudio}
          resumeCurrentAudio={resumeCurrentAudio}
          adjustPlaybackRate={adjustPlaybackRate}
          activeAudio={activeAudio}
          isPaused={isPaused}
          selectedRates={selectedRates}
          isSmallScreen={isSmallScreen}
          handleFeedback={handleFeedback}
          loadingFeedback={loadingFeedback}
          feedbackGiven={feedbackGiven}
          showDownOptions={showDownOptions}
          setShowDownOptions={setShowDownOptions}
          handleSubmitFeedback={handleSubmitFeedback}
          setShowFeedbackModal={setShowFeedbackModal}
          showSkeleton={
            isLoadingResponse && msg === lastMessage && !isLastMessageFromTrixie
          }
        />
      ))}
    </div>
  );
};

export default ChatLog;
